import React from "react";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import RailIconFO from "../../../icons/RailIconFO";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { useAnchorPosition } from "./multiLocationQuoteUtils";

// TODO: is it ok that this panel doesn't cross into the map section?
const AdditionalCarriersPanel: React.FC<{ carriers: string[] }> = ({
  carriers,
}) => {
  const [anchorForAdditionalCarriersPanel] = useNitroCAStore((state) => [
    state.anchorForAdditionalCarriersPanel,
  ]);
  const anchorPosition = useAnchorPosition(anchorForAdditionalCarriersPanel);
  return (
    <div
      className={styles.additionalCarriersPanelContainer}
      style={{
        top: anchorPosition.top,
        left: anchorPosition.left - 40,
      }}
    >
      {/* Title */}
      <div className={styles.additionalCarriersTitle}>Carrier Detail</div>
      {/* Content */}
      <div className={styles.additionalCarriersContent}>
        <RailIconFO color="#F97316" />
        {carriers.map((carrier, index) => (
          <>
            <span key={carrier} className={styles.inboundModesCarrier}>
              {carrier}
            </span>
            {index !== carriers.length - 1 && (
              <span className={styles.inboundModesDot} />
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default AdditionalCarriersPanel;
